import React from 'react';
import { observer } from "mobx-react";
import uniqueId from 'lodash/uniqueId';
import { Icon } from 'components/Icon';
import { OnVoardLogo, OnVoardIcon } from 'components/Svg';
import MenuItem from '../MenuItem';
import consoleStore from 'stores/Console/ConsoleStore';
import constants from 'Constants';
import * as paths from 'Paths';
import * as utils from 'Utils';
import './styles.scss';


@observer
class EcommerceMenu extends React.Component {
  constructor (props) {
    super(props);

    const qs = {};
    qs['theme'] = props.theme;

    this.productsUrl = utils.appendQueryString(paths.getPathProducts(), qs);
    this.webTrackingUrl = paths.getPathWebTracking();
    this.conversionSettingsUrl = paths.getPathConversionSettings();

    this.shopifySettingsUrl = utils.appendQueryString(paths.getPathShopifySettings(), qs);
    this.bigCommerceSettingsUrl = utils.appendQueryString(paths.getPathBigCommerceSettings(), qs);
    this.easyStoreSettingsUrl = utils.appendQueryString(paths.getPathEasyStoreSettings(), qs);
    this.shoplineSettingsUrl = utils.appendQueryString(paths.getPathShoplineSettings(), qs);
    this.wixSettingsUrl = utils.appendQueryString(paths.getPathWixSettings(), qs);
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu("ECOMMERCE");
    }
  }

  getSubMenus = () => {
    const { activeSidebar, history, theme, displayProducts } = this.props;
    const account = consoleStore.account;

    let subMenus = [{
        display: displayProducts ? true : false,
        id: constants.ECOMMERCE_SIDEBAR.ECOMMERCE_PRODUCTS,
        label: "Products",
        href: this.productsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.productsUrl),
        isActive: activeSidebar === constants.ECOMMERCE_SIDEBAR.ECOMMERCE_PRODUCTS
    }, {
        display: account.isEcommercePlatformShopify,
        id: constants.ECOMMERCE_SIDEBAR.SHOPIFY_SETTINGS,
        label: "Shopify Settings",
        href: this.shopifySettingsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.shopifySettingsUrl),
        isActive: activeSidebar === constants.ECOMMERCE_SIDEBAR.SHOPIFY_SETTINGS
    }, {
        display: account.isEcommercePlatformBigCommerce,
        id: constants.ECOMMERCE_SIDEBAR.BIGCOMMERCE_SETTINGS,
        label: "BigCommerce Settings",
        href: this.bigCommerceSettingsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.bigCommerceSettingsUrl),
        isActive: activeSidebar === constants.ECOMMERCE_SIDEBAR.BIGCOMMERCE_SETTINGS
    }, {
        display: account.isEcommercePlatformEasyStore,
        id: constants.ECOMMERCE_SIDEBAR.EASYSTORE_SETTINGS,
        label: "EasyStore Settings",
        href: this.easyStoreSettingsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.easyStoreSettingsUrl),
        isActive: activeSidebar === constants.ECOMMERCE_SIDEBAR.EASYSTORE_SETTINGS
    }, {
        display: account.isEcommercePlatformShopline,
        id: constants.ECOMMERCE_SIDEBAR.SHOPLINE_SETTINGS,
        label: "Shopline Settings",
        href: this.shoplineSettingsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.shoplineSettingsUrl),
        isActive: activeSidebar === constants.ECOMMERCE_SIDEBAR.SHOPLINE_SETTINGS
    }, {
        display: account.isEcommercePlatformWix,
        id: constants.ECOMMERCE_SIDEBAR.WIX_SETTINGS,
        label: "Wix Settings",
        href: this.wixSettingsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.wixSettingsUrl),
        isActive: activeSidebar === constants.ECOMMERCE_SIDEBAR.WIX_SETTINGS
    }, {
        display: theme === constants.PRODUCT_MARKETING_PLATFORM && !account.isEcommercePlatformShopline,
        id: constants.ECOMMERCE_SIDEBAR.WEB_TRACKING,
        label: "Web Tracking",
        href: this.webTrackingUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.webTrackingUrl),
        isActive: activeSidebar === constants.ECOMMERCE_SIDEBAR.WEB_TRACKING
    }, {
        display: theme === constants.PRODUCT_MARKETING_PLATFORM,
        id: constants.ECOMMERCE_SIDEBAR.CONVERSION_SETTINGS,
        label: "Conversion Settings",
        href: this.conversionSettingsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.conversionSettingsUrl),
        isActive: activeSidebar === constants.ECOMMERCE_SIDEBAR.CONVERSION_SETTINGS
    }];

    return subMenus;
  };

  checkIsActive = () => {
    return this.getSubMenus().some((subMenu) => subMenu.isActive);
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = this.getSubMenus();

    return (
      <MenuItem
        menuId="ECOMMERCE"
        menuName="Ecommerce"
        icon="basket"
        subMenus={subMenus}
        isActive={this.checkIsActive()}
        {...this.props}
      />
    );
  }
}




export default EcommerceMenu;
